export default {
  'Sample photo': 'Sample photo',
  Removing: 'Removing',
  Edit: 'Edit',
  'Adjust Picture': 'Adjust Picture',
  Restore: 'Restore',
  Eraser: 'Eraser',
  Size: 'Size',
  Background: 'Background',
  Custom: 'Custom',
  Presets: 'Presets',
  'Add Image': 'Add Image',
  'Scale to Fit': 'Scale to Fit',
  'Full Width': 'Full Width',
  'Full Height': 'Full Height',
  Move: 'Move',
  Undo: 'Undo',
  Redo: 'Redo',
  Enlarge: 'Enlarge',
  Reduce: 'Reduce',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Online Background Remover',
    desc: 'Easily remove the background of your photos 100% automatically & free',
    imgAlt: 'photo background remover',
    submitBtn: 'Remove Background',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
    "Upload failed, click to try again": "Upload failed, click to try again",
};
